import React from 'react';
import '@/App.css';
import { Toaster } from 'sonner';
import { Nav } from '@/components/site/Nav';
import { Hero } from '@/components/site/Hero';
import { About } from '@/components/site/About';
import { ImageBreak } from '@/components/site/ImageBreak';
import { Process } from '@/components/site/Process';
import { Services } from '@/components/site/Services';
import { Portfolio } from '@/components/site/Portfolio';
import { Clients } from '@/components/site/Clients';
import { Contact } from '@/components/site/Contact';
import { Footer } from '@/components/site/Footer';
import { WhatsAppFloat } from '@/components/site/WhatsAppFloat';

function App() {
    return (
        <div className="App bg-black text-white min-h-screen">
            <Nav />
            <main>
                <Hero />
                <About />
                <ImageBreak />
                <Services />
                <Process />
                <Portfolio />
                <Clients />
                <Contact />
            </main>
            <Footer />
            <WhatsAppFloat />
            <Toaster
                position="top-right"
                theme="dark"
                toastOptions={{
                    style: {
                        background: '#0a0a0a',
                        border: '1px solid rgba(201,162,39,0.4)',
                        color: '#ffffff',
                    },
                }}
            />
        </div>
    );
}

export default App;
